module.exports = __webpack_public_path__ + "static/img/101800.f17f35b4.png";